export default [
    {
        path: 'relatorio-historico-permissao-papel',
        component: () => import(
            /* webpackChunkName: 'administracao-relatorio-historico-permissao-papel' */
            '@/views/administracao/relatorio-historico-permissao-papel/Index'
        ),
        redirect: 'relatorio-historico-permissao-papel/index',
        children: [
            {
                name: 'administracao-relatorio-historico-permissao-papel-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-relatorio-historico-permissao-papel' */
                    '@/views/administracao/relatorio-historico-permissao-papel/List'
                ),
            },
        ]
    }
]